import useIdleHeartbeat from 'hooks/useIdleHeartbeat';

// Side-effect-only wrapper so the hook can be declared by mount position in
// the render tree (App.tsx isAuthorized block) — automatic mount on login,
// automatic cleanup on logout via React lifecycle.
const IdleHeartbeat = (): null => {
  useIdleHeartbeat();
  return null;
};

export default IdleHeartbeat;
